import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import { createSelector } from 'reselect';
import { utcToTzDate } from "../helpers/convertEpochToDate";

var alertsListReducer = function alertsListReducer(state) {
  return state.alertsListReducer;
};

export var getAlertsTableData = function getAlertsTableData() {
  var alerts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return _mapInstanceProperty(alerts).call(alerts, function (alert) {
    var alertId = alert.alertId,
        severity = alert.severity,
        alertTypeName = alert.alertTypeName,
        occurrenceTime = alert.occurrenceTime,
        attributes = alert.attributes;
    var source = {};
    var detail = {};

    if (attributes && attributes.length) {
      source = _findInstanceProperty(attributes).call(attributes, function (attribute) {
        return attribute.name === 'source';
      });
      detail = _findInstanceProperty(attributes).call(attributes, function (attribute) {
        return attribute.name === 'details';
      });
    }

    return {
      id: alertId,
      severityType: severity,
      alertTypeName: alertTypeName,
      source: source,
      detail: detail,
      occurrenceTime: utcToTzDate(occurrenceTime),
      data: alert
    };
  });
};
export var alertsListSelector = createSelector(alertsListReducer, function (reducer) {
  return _objectSpread(_objectSpread({}, reducer), {}, {
    alerts: getAlertsTableData(reducer.alerts)
  });
});